import React, { Component } from 'react'
import { Button, Modal } from 'semantic-ui-react'
import { getUiMessage } from 'Features/ui/selectors'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withRouter } from 'react-router-dom'

class ErrorMessage extends Component {
  state = { open: this.props.hasError }

  show = dimmer => () => this.setState({ dimmer, open: true })
  close = () => {
    this.setState({ open: false })
    // if (this.props.location.pathname === '/login')
    //   window.location.reload()
    if (this.props.match.url === '/login')
      window.location.reload()
    if ((this.props.location.pathname).indexOf("undefined") !== -1) {
      window.location.replace("/")
    }
    else {
      this.props.history.go(-1)
    }
  }

  render() {
    const { dimmer } = this.state
    const { errorCode, errorMessage /*, statusText*/ } = this.props.uiError
    return (
      <div>
        <Modal open={this.state.open} dimmer={dimmer} onClose={this.close}>
          <Modal.Header>Something went wrong !</Modal.Header>
          <Modal.Content>
            <Modal.Description>
              {/* <h2>{statusText}</h2> */}
              <p>Error Code : {errorCode}</p>
              <p>Error Message : {errorMessage}</p>
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <Button
              positive
              icon='checkmark'
              labelPosition='right'
              content="OK"
              onClick={this.close}
            />
          </Modal.Actions>
        </Modal>
      </div>
    )
  }
}
ErrorMessage = compose(
  withRouter,
  connect(
    (state, props) => ({
      uiError: getUiMessage(state),
    })
  )

)(ErrorMessage)

export default ErrorMessage


// WEBPACK FOOTER //
// ./src/features/ui/components/ErrorMessage.js